/**
 * Shared layout tokens consumed by Sidebar and page headers.
 * Both must use the same height so their bottom borders form a single line.
 */
export const APP_HEADER_HEIGHT = "h-[79px]";
